module.exports = __webpack_public_path__ + "static/media/user-placeholder.6a20c676.png";